import { translation, TranslatedComponent, numberFormatter } from '@hh.ru/front-static-app';
import { Tag, TagStyle, Text, Title } from '@hh.ru/magritte-ui';
import { ArrowDownOutlinedSize16, ArrowUpOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import { ProfessionAreaChartDirection as Direction, ProfessionAreaChartItem } from 'src/models/pages/profession';
import { getCurrency } from 'src/utils/currency';

import styles from './styles.less';

const TrlKeys = {
    description: 'career-platform.profession.sections.statistic.chart.common.header.description',
};

interface Props {
    selectedItem: ProfessionAreaChartItem;
}

const tagStyles: Record<Direction, TagStyle> = {
    [Direction.MORE]: 'positive',
    [Direction.LESS]: 'negative',
    [Direction.EQUAL]: 'neutral',
};

const icon = {
    [Direction.MORE]: ArrowUpOutlinedSize16,
    [Direction.LESS]: ArrowDownOutlinedSize16,
    [Direction.EQUAL]: undefined,
};

const AreaChartHeader: TranslatedComponent<Props> = ({ selectedItem, trls }) => (
    <div className={styles.container}>
        <Title size="medium" Element="h2">
            {selectedItem.isCurrency
                ? getCurrency(selectedItem.value)
                : numberFormatter.format(selectedItem.value.toString())}
        </Title>
        {!!selectedItem.diff.value && (
            <>
                <div className={styles.tagContainer}>
                    {/* TODO: fix ts error after magritte-ui update */}
                    {/* @ts-expect-error */}
                    <Tag style={tagStyles[selectedItem.diff.direction]} icon={icon[selectedItem.diff.direction]}>
                        {selectedItem.isCurrency
                            ? getCurrency(selectedItem.diff.value)
                            : numberFormatter.format(selectedItem.diff.value.toString())}
                    </Tag>
                </div>
                <Text typography="label-4-regular">{trls[TrlKeys.description]}</Text>
            </>
        )}
    </div>
);

export default translation(AreaChartHeader);
